import { useState } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import type { JSONContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import { MentionExtension } from './extensions/MentionExtension';
import { SongReferenceExtension } from './extensions/SongReferenceExtension';
import { EditorToolbar } from './EditorToolbar';
import { CharacterCounter } from './CharacterCounter';
import './editor.css';

interface RichTextEditorProps {
    placeholder?: string;
    maxLength?: number;
    onUpdate?: (content: JSONContent, text: string) => void;
    onSubmit?: () => void;
}

export function RichTextEditor ({ placeholder, maxLength = 500, onUpdate }: RichTextEditorProps) {
    const [charCount, setCharCount] = useState(0);

    const editor = useEditor({
        extensions: [
            StarterKit.configure({
                heading: false,
                codeBlock: false,
            }),
            Underline,
            Link.configure({
                openOnClick: false,
                HTMLAttributes: {
                    rel: 'nofollow noopener',
                    target: '_blank',
                },
            }),
            Placeholder.configure({
                placeholder: placeholder || "What's on your mind?",
            }),
            MentionExtension,
            SongReferenceExtension,
        ],
        onUpdate: ({ editor }) => {
            const text = editor.getText();
            setCharCount(text.length);
            onUpdate?.(editor.getJSON(), text);
        },
    });

    return (
        <div className="rich-editor bg-[#0B0D10] rounded-xl border border-white/[0.08]">
            <EditorToolbar editor={editor} />
            <div className="px-4 py-3">
                <EditorContent editor={editor} />
            </div>
            <div className="px-4 py-2 border-t border-white/[0.06] flex justify-end">
                <CharacterCounter current={charCount} max={maxLength} />
            </div>
        </div>
    );
}